import {
  formatCompact3SignificantDigits,
  MetricCard,
  MetricSize,
  useTimeDistance
} from "@quortex/front-common"

interface ActiveViewersCardProps {
  viewers: api.switchns.OverallViewers
  refetchedAt: Date
  className?: string
}
const ActiveViewersCard = ({ viewers, ...props }: ActiveViewersCardProps) => {
  const timeDistance = useTimeDistance(props.refetchedAt?.toISOString() ?? "")

  return (
    <MetricCard
      hasNoData={viewers.viewersCount === 0}
      size={MetricSize.LARGE}
      subtext={props.refetchedAt ? `Updated: ${timeDistance}` : ""}
      title="Active viewers"
      {...(viewers.trend !== "stable" && { trend: viewers.trend })}
      valueLabel={formatCompact3SignificantDigits(viewers.viewersCount)}
    />
  )
}

export default ActiveViewersCard
